import axios from "../../config/axiosConfig";
import {
  PRODUCTION_DETAIL_GRAY_REPORT_REQUEST,
  PRODUCTION_DETAIL_GRAY_REPORT_SUCCESS,
  PRODUCTION_DETAIL_GRAY_REPORT_FAILURE,
  PRODUCTION_DETAIL_GRAY_FILTER_REPORT_REQUEST,
  PRODUCTION_DETAIL_GRAY_FILTER_REPORT_SUCCESS,
  PRODUCTION_DETAIL_GRAY_FILTER_REPORT_FAILURE
} from "../types/production-detail-gray-report-types";

export const getProductionDetailGrayReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_DETAIL_GRAY_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        finyearId: params?.finyearId,
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Log the request parameters
      console.log('Request Param Datas >>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/production-detail-report/getGrayReport?${queryString}`;

      // Log the full URL (to debug)
      console.log('>>Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('<<<Purchase API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: PRODUCTION_DETAIL_GRAY_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching production detail gray Report:", error);
        dispatch({ type: PRODUCTION_DETAIL_GRAY_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching production detail gray Report:", error);
      dispatch({ type: PRODUCTION_DETAIL_GRAY_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getProductionDetailGrayFilterDetail = (params) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: PRODUCTION_DETAIL_GRAY_FILTER_REPORT_REQUEST });

            const { auth } = getState();
            const defaultParams = {
                finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth.user?.Customer_Id,
            };
            const requestParams = { ...defaultParams };

            const queryString = new URLSearchParams(requestParams).toString();
            const fullUrl = `/production-detail-report/filter-detail/gray?${queryString}`;

            console.log('<<Complete API Request URL: ', fullUrl);

            return axios.get(fullUrl).then((response) => {
                console.log('<<purchase-API Response Data: ', response);
                if (response.data) {
                  dispatch({ type: PRODUCTION_DETAIL_GRAY_FILTER_REPORT_SUCCESS, payload: response.data });
                }
            }).catch((error) => {
                console.error("Error fetching production detail gray Report:", error);
                dispatch({ type: PRODUCTION_DETAIL_GRAY_FILTER_REPORT_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error("Error fetching production detail gray Report:", error);
            dispatch({ type: PRODUCTION_DETAIL_GRAY_FILTER_REPORT_FAILURE, error: error.message });
        }
    };
};

export const clearProductionDetailGrayReport = () => {
  return async (dispatch) => {
        dispatch({ type: PRODUCTION_DETAIL_GRAY_REPORT_SUCCESS, payload: {} });
  }
}
